module.exports = __webpack_public_path__ + "img/d4bdb79.jpg";